import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { Faq } from 'common';
import { fetchFaq } from './FaqSlice';
import { FaqContentSelector } from './FaqContentSelector';

export function useFaq(): AbstractContentState<Faq> {
    return useCmsContent(fetchFaq, FaqContentSelector);
}
